<template>
  <modal
    name="create-validation-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Create Validation</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Validation name (required)</label
            >
            <input
              type="text"
              class="textInputField"
              placeholder="Enter a validation name"
              v-model="validation_name"
            />
          </div>

          <div class="form-group">
            <label class="txt--xs txt--off-white"
              >Validation price (required)</label
            >
            <div class="input-group-prfix">
              <span class="input-group-prefix-text">$</span
              ><input
                type="number"
                placeholder="Enter validation price"
                class="textInputField"
                v-model="validation_price"
              />
            </div>
          </div>
          <div class="form-group modified-toggle-switch">
            <div class="d-flex align-items-center flex-wrap mb-2">
              <p class="txt--xs txt--off-white">Properties (required)</p>

              <app-toggle
                :checked="all_properties"
                :label="'All Properties'"
                @update:checked="getCheckedStatus($event, 'all_properties')"
              >
              </app-toggle>
            </div>
          </div>

          <div class="form-group modified-toggle-switch" v-if="all_properties == false">
            <div class="d-flex align-items-center mb-2">
              <multiselect
                v-model="selected_property_list"
                class="multi-select-input"
                :options="property_list"
                :multiple="true"
                placeholder="Select Properties"
                track-by="property_name"
                label="property_name"
              >
              </multiselect>
            </div>
          </div>
          <div class="form-group modified-toggle-switch">
            <div class="d-flex align-items-center mb-2">
              <p class="txt--xs txt--off-white">Duration (required)</p>
              <app-toggle 
                :checked="validity_time" 
                :label="'All Day'"
                @update:checked="getCheckedValidity($event, 'validity_time')"
              >
              </app-toggle>
            </div>
          </div>
          <div class="form-group" v-if="validity_time === false">
            <label for="durationRange" class="txt--xs txt--off-white">Validation Duration Time in Hours</label>
            <div class="d-flex justify-content-between align-items-center durationRangeWrpr">
              <input type="text" class="textInputField input" value="1" readonly>
              <input type="range" class="form-range" min="1" :max="rangeMax" step="1" id="durationRange" v-model="durationRange" :style=" 'background: linear-gradient(to right, #f6ba58 0%, #f6ba58 '+rangePer +'%, #42413d ' + rangePer + '%, #42413d 100%)' " />
              <input type="text" class="textInputField input" v-model="durationRange">
            </div>
          </div>
          <div class="form-group">
            <label for="durationExpRange" class="txt--xs txt--off-white">Validation Link Expiry Time in Minutes</label>
            <div class="d-flex justify-content-between align-items-center durationRangeWrpr">
              <input type="text" class="textInputField input" value="1" readonly>
              <input type="range" class="form-range" min="1" :max="rangeExpMax" step="1" id="durationExpRange" v-model="durationExpRange" :style=" 'background: linear-gradient(to right, #f6ba58 0%, #f6ba58 '+rangeExpPer +'%, #42413d ' + rangeExpPer + '%, #42413d 100%)' " />
              <input type="text" class="textInputField input" v-model="durationExpRange">
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner 
          class="button button--primary button--sm mr-3" 
          @click="saveValidation"
          :disabled="create_button.disabled"
          :loading="create_button.loading"
          :success="create_button.success"
        >
          Create</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
// import { ModelSelect, ModelListSelect } from "vue-search-select";
import Toggle from "@/components/toggle";
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "CreateValidation",
  components: {
    AppToggle: Toggle,
    // datetime: Datetime,
    // ModelSelect,
    ButtonWithSpinner,
  },
  data() {
    return {
      validation_name: '',
      validation_price: null,
      all_properties: true,
      validity_time: true,
      validation_duration: '',
      property_list: {},
      selected_property_list: null,
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },
      durationRange: 0,
      rangeMax : 72,
      rangePer: 0,
      durationExpRange : 15,
      rangeExpMax : 72,
      rangeExpPer: 0,
    };
  },
  created() {
    this.getProperties();
  },
  methods: {
    getCheckedValidity(checked, type)
    {
      if(type == 'validity_time')
      {
        this.resetValidationHourSlider();
        this.validity_time          = checked;
       // this.selected_property_list = null;
      }
    },
    closeModal() {
      this.resetValidationForm();
      this.$modal.hide("create-validation-modal");
    },
    getCheckedStatus(checked, type)
    {
      if(type == 'all_properties')
      {
        this.all_properties       = checked;
        this.validition_duration  = '';
        if(checked==true){
          this.selected_property_list = null;
        }
      }
    },
    getProperties()
    {
      this.axios
        .post(window.hostname + "api/auth/all-space", {
          limit: 500,
          device_type: 1,
          space_type: 1,
          status: 0,
          page: 1,
          minify: 1,
          minify_2: 0,
          time_zone: this.$moment.tz.guess(new Date()),
        })
        .then((res) => {
          if (res.data.status) {
            this.property_list = res.data.data.all_space;
          } else {
            this.property_list = [];
          }
        })
        .catch((err) => {
          this.property_list = [];
        });
    },

    // Only comercial user can create the validation
    saveValidation()
    {
      if(this.validation_name == '')
      {
          this.$toasted.show('Please type validation name !', {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
      }
      if(this.validation_price == '' || this.validation_price == null)
      {
          this.$toasted.show('Please type validation price !', {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
      }
      if(this.validity_time == false && this.durationRange == '')
      {
          this.$toasted.show('Please type validation duration in hours!', {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
      }

      if(this.durationExpRange == '')
      {
          this.$toasted.show('Please type validation expiry duration in minutes!', {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
      }

      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;

      this.axios
        .post(window.hostname + "api/auth/validation/createValidations", {
          name:                       this.validation_name,
          price:                      this.validation_price,
          device_type:                1,
          validity_time:              this.validity_time,
          property_list:              this.selected_property_list,
          all_properties:             this.all_properties,
          validation_duration:        this.durationRange,
          validation_duration_type:   'hours',
          expiry_duration:            this.durationExpRange,
          expiry_duration_type:       'minutes',
        })
        .then((res) => {
          this.$emit('update_validation_list');
          this.closeModal();
          this.$toasted.show('Validation added successfully !', {
              icon: "check-circle",
              className: "success-class",
            });

          //this.resetValidationHourSlider();
          //this.resetValidationExpHourSlider();
          this.resetValidationForm();
          
        })
        .catch((err) => {
          this.$toasted.show('Something went wrong!', {
            icon: "times-circle",
              className: "error-class",
            });
            this.create_button.disabled = false;
            this.create_button.success = false;
            this.create_button.loading = false;
        });
    },
    resetValidationHourSlider()
    {
        this.rangePer       = 0;
        this.rangeMax       = 72;
        this.durationRange  = 1;
    },
    resetValidationExpHourSlider()
    {
        this.rangeExpPer       = 0;
        this.rangeExpMax       = 72;
        this.durationExpRange  = 15;
    },
    resetValidationForm()
    {
      this.validation_name  = '';
      this.validation_price = null;
      this.all_properties   = true;
      this.validity_time    = true;
      this.selected_property_list = null;
      this.create_button.disabled = false;
      this.create_button.success = false;
      this.create_button.loading = false;
      this.resetValidationExpHourSlider();
      this.resetValidationHourSlider();
    },
  },
  watch:{
    durationRange: function(){
      this.rangePer =  (this.durationRange/this.rangeMax ) * 100
    },
    durationExpRange: function(){
      this.rangeExpPer =  (this.durationExpRange/this.rangeExpMax ) * 100
    }
  }
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
</style>